import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import {
  Grid,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core'

// actions
import {
  getMemberGroups,
  updateMemberGroup,
  addNewMemberGroup,
  deleteMemberGroup,
} from '../../../actions/company'
import { getShopList } from '../../../actions/shop'
import { openErrorMessage } from '../../../actions/message'

// utils
import { sortArrayByName } from '../../../utils/array'
import { globalValidator } from '../../../utils/validations/common'
import { hasAccess } from '../../../utils/api'

// local components
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import MembershipItemContainer from '../../../components/MemberGroups/MembershipItemContainer'
import ModalDialog from '../../../components/common/ModalDialog'
import { Appcues } from '../../../utils/constants'

const emptyMemberGroup = {
  name: '',
  enabled: false,
  discountType: 'Cash',
}

class CompanyMemberShips extends PureComponent {
  state = {
    showEmptyMemberGroup: false,
    selectedToDeleteMemberGroup: {},
  }

  componentDidMount() {
    this.props.dispatch(getMemberGroups())
    this.props.dispatch(getShopList())
  }

  onMemberGroupUpdate = (data, afterOnSave) => {
    const keys = [{ name: 'name', title: 'Name', validateKey: 'required' }]

    // if(!data.enablePromotion) {
    //     keys.push({name: 'discount', title: 'Discount Amount', validateKey: 'required'});
    // }

    if (data && data.discount < 0) {
      this.props.dispatch(openErrorMessage('Discount Amount is Required'))
    } else {
      const valid = globalValidator(data, keys)

      if (valid === true) {
        this.props.dispatch(updateMemberGroup(data)).then((response) => {
          Appcues.track('Memeber group updated')
          this.props.dispatch(getMemberGroups())
          afterOnSave(response)
        })
      } else {
        this.props.dispatch(openErrorMessage(valid))
      }
    }
  }

  openDeleteModal = (terminal) => (e) => {
    this.setState({
      selectedToDeleteMemberGroup: terminal,
    })

    this.deleteModal.handleClickOpen()
  }

  onDeleteMemberGroup = (terminal) => (e) => {
    this.deleteModal.handleClose()

    this.props.dispatch(deleteMemberGroup(terminal.id)).then((response) => {
      Appcues.track('Member Group Deleted')
      this.props.dispatch(getMemberGroups())
    })
  }

  toggleEmptyMemberGroup = () => {
    Appcues.track('Adding member group')
    this.setState((prevState) => ({
      showEmptyMemberGroup: !prevState.showEmptyMemberGroup,
    }))
  }

  addNewMemberGroup = (data, afterOnSave) => {
    this.props.dispatch(addNewMemberGroup(data)).then((terminal) => {
      Appcues.track('New Member Added')
      this.props.dispatch(getMemberGroups())
      this.toggleEmptyMemberGroup()
    })
  }

  render() {
    const { memberGroups = {}, lastModified = null } = this.props.companyReducer

    const { showEmptyMemberGroup, selectedToDeleteMemberGroup } = this.state

    const memberGroupsValues = sortArrayByName(memberGroups.values)

    return (
      <div>
        <Grid container>
          <Grid className="addButton" item xs={12} sm={12} md={12} lg={12}>
            {hasAccess() ? (
              <Button
                variant="raised"
                className="primary-button pull-right margin-bottom-small"
                onClick={this.toggleEmptyMemberGroup}
              >
                Add Member Group
              </Button>
            ) : null}
          </Grid>
        </Grid>
        <Grid container>
          <Grid className="fullWidth" item xs={12} sm={12} md={12} lg={12}>
            <Paper>
              <div className="table-scroll">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Default Group</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Active</TableCell>
                      <TableCell>Enable Promotion</TableCell>
                      <TableCell>Discount Type</TableCell>
                      <TableCell>Amount</TableCell>
                      {hasAccess() ? <TableCell></TableCell> : null}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {showEmptyMemberGroup ? (
                      <MembershipItemContainer
                        memberGroup={emptyMemberGroup}
                        lastModified={lastModified}
                        onMemberGroupUpdate={this.addNewMemberGroup}
                        onCancel={this.toggleEmptyMemberGroup}
                        defaultEditMode={true}
                      />
                    ) : null}
                    {memberGroupsValues.map((row, index) => {
                      return (
                        <MembershipItemContainer
                          key={index}
                          memberGroup={row}
                          lastModified={lastModified}
                          onMemberGroupUpdate={this.onMemberGroupUpdate}
                          onDelete={this.openDeleteModal(row)}
                        />
                      )
                    })}
                  </TableBody>
                </Table>
              </div>
            </Paper>
          </Grid>
          <ModalDialog
            ref={(c) => (this.deleteModal = c)}
            onConfirm={this.onDeleteMemberGroup(selectedToDeleteMemberGroup)}
            confirmText="delete"
          >
            Are you sure you want to delete '{selectedToDeleteMemberGroup.name}'
          </ModalDialog>
        </Grid>
      </div>
    )
  }
}

export default connect(({ dispatch, shopReducer, companyReducer }) => ({
  dispatch,
  shopReducer,
  companyReducer,
}))(ContainerWithTitle(CompanyMemberShips, 'Memberships'))



// WEBPACK FOOTER //
// ./src/containers/Settings/Company/CompanyMemberships.js